'use strict';

module.exports = function isSamsungBrowser(ua) {
  ua = ua || global.navigator.userAgent;
  return /SamsungBrowser/i.test(ua);
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-samsung.js
// module id = 642
// module chunks = 0